const commonRegExes = {
	password: /^.{8,}$/,
	alphanumeric: /[^a-zA-Z0-9]/
}

export default commonRegExes
